import { useEffect, useState } from 'react';

interface LatestRelease {
  version: string;
  publishedAt: string;
  sizeBytes: number;
  notes: string;
  sha256: string;
}

export function useLatestRelease(): LatestRelease | null {
  const [release, setRelease] = useState<LatestRelease | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetch('/api/v1/releases?channel=stable&limit=1')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data?.items?.length > 0) {
          const item = data.items[0];
          setRelease({
            version: item.version,
            publishedAt: item.publishedAt,
            sizeBytes: item.sizeBytes,
            notes: item.notes,
            sha256: item.sha256,
          });
        }
      })
      .catch(() => {});

    return () => { cancelled = true; };
  }, []);

  return release;
}
